import { useState } from "react";
import { useTranslation } from "react-i18next";
import { GridColDef } from "@mui/x-data-grid";
import { Box, AlertColor } from "@mui/material";

import BoxContent from "../../components/boxContent";
import QuickAlert from "../../components/form/quickAlert";
import ReorderTable from "../../components/ReorderTable";

import ModalBannerControl from "./modalBannerControl";

import { Data, PageStateType } from "../../interfaces/IDataGridApiSearch";

export default function Banners() {
  const { t } = useTranslation();
  const [dataUpdated, setDataUpdated] = useState(0);
  const [isEdition, setIsEdition] = useState<boolean>(false);
  const [dataToEditionBanner, setDataToEditionBanner] = useState(null);
  const [titleQuickAlert, setTitleQuickAlert] = useState<string>("");
  const [messageQuickAlert, setMessageQuickAlert] = useState<string>("");
  const [visibleQuickAlert, setVisibleQuickAlert] = useState<boolean>(false);
  const [severityQuickAlert, setSeverityQuickAlert] =
    useState<AlertColor>("success");
  const [openModalBannerControl, setOpenModalBannerControl] =
    useState<boolean>(false);
  const [dataTable, setDataTable] = useState<PageStateType>({
    isLoading: false,
    data: [],
    total: 0,
    page: 0,
    pageSize: 25,
  });
  const [reorderPayload, setReorderPayload] = useState<
    Record<string, any> | any
  >({});

  const refreshPage = () => {
    setDataUpdated(dataUpdated + 1);
  };

  const openQuickAlert = (
    severity: AlertColor,
    title: string,
    message?: string,
  ) => {
    setSeverityQuickAlert(severity);
    setTitleQuickAlert(title);
    message && setMessageQuickAlert(message);
    setVisibleQuickAlert(true);
  };

  const openModalBanner = (isEdition: boolean, editRowData?: any) => {
    isEdition &&
      setDataToEditionBanner({
        ...editRowData,
        typeLink: editRowData.isInternalLink
          ? t("banners.modal.linkTypeOption1")
          : t("banners.modal.linkTypeOption2"),
        displayOrder:
          editRowData.displayOrder < 10
            ? `0${editRowData.displayOrder}`
            : editRowData.displayOrder.toString(),
      });
    setIsEdition(isEdition);
    setOpenModalBannerControl(true);
  };

  const columns: GridColDef[] = [
    {
      field: "__drag",
      headerName: t("banners.table.reorder"),
      flex: 2,
      headerClassName: "header-style",
      sortable: false,
      filterable: false,
    },
    {
      field: "displayOrder",
      headerName: t("banners.table.position"),
      flex: 2,
      headerClassName: "header-style",
    },
    {
      field: "image",
      headerName: t("banners.table.image"),
      flex: 3,
      headerClassName: "header-style",
      renderCell: (params) => (
        <img src={params.row?.image} alt="imagem do banner" width={130} />
      ),
    },
    {
      field: "name",
      headerName: t("banners.table.name"),
      flex: 2,
      headerClassName: "header-style",
    },
    {
      field: "description",
      headerName: t("banners.table.description"),
      flex: 3,
      headerClassName: "header-style",
    },
    {
      field: "redirectLink",
      headerName: t("banners.table.link"),
      flex: 3,
      headerClassName: "header-style",
    },
    {
      field: "active",
      headerName: t("banners.table.status"),
      flex: 2,
      headerClassName: "header-style",
      renderCell: (params) => {
        const status =
          params.row.active === true
            ? t("banners.active")
            : t("banners.inactive");
        return <p>{status}</p>;
      },
    },
  ];

  const createReorderPayload = (
    item: { item: Data; toOrder: number } | null,
  ) => {
    if (item) {
      setReorderPayload(item?.toOrder);
    }
  };

  return (
    <BoxContent
      title={t("banners.title")}
      button
      handleClick={() => {
        setDataToEditionBanner(null);
        openModalBanner(false);
      }}
      titleButton={t("banners.addBanner")}
    >
      <Box marginTop={3} marginBottom={3} fontWeight={400} color="#000">
        {t("banners.textPage")}
      </Box>

      <QuickAlert
        visibility={visibleQuickAlert}
        severity={severityQuickAlert}
        title={titleQuickAlert}
        description={messageQuickAlert}
        hanhleClose={() => setVisibleQuickAlert(false)}
      />

      <ReorderTable
        endPoint="banners?"
        reorderEndPoint="banners/displayOrder/"
        onReorderedItem={(item) => createReorderPayload(item)}
        reorderPayload={reorderPayload}
        labelParams1={t("revalidation.list.searchInputText")}
        params1="&searchText="
        cleanButtonText={t("revalidation.list.cleanButtonText")}
        cleanButtonType="outlined"
        cleanButtonStyle={{
          backgroundColor: "white",
          color: "#00B0F0",
          borderColor: "#00B0F0",
          width: 120,
        }}
        columnsData={columns}
        onRowClick={(row: Data) => openModalBanner(true, row)}
        refreshTable={dataUpdated}
        onPageStateChange={(state) => setDataTable(state)}
        gridColumns="3fr 3fr 4fr 4fr 4fr 4fr 3fr"
        tableWidthMobile="950px"
      />

      {openModalBannerControl && (
        <ModalBannerControl
          onClose={() => setOpenModalBannerControl(false)}
          bannerData={dataToEditionBanner}
          isEdition={isEdition}
          openSucessQuickAlert={() => {
            refreshPage();
            openQuickAlert("success", t("quickAlert.sucess"));
          }}
          openErrorQuickAlert={() =>
            openQuickAlert("error", t("quickAlert.error2"))
          }
          messageQuickAlert={setMessageQuickAlert}
          totalPositions={dataTable.total}
        />
      )}
    </BoxContent>
  );
}
